/* ============
 * Auth Module
 * ============
 */

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: {
    isAuthenticated: false,
    tokenExpires:	0,
  },
  actions,
  getters,
  mutations,
};
